var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFumigation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1442 21.1764V18.5882H25.7905L29 17.5096L28.5947 16.2819L25.5824 17.2941H23.1442V14.7059H25.1182L28.2618 11.5351L27.3547 10.6201L24.587 13.4118H23.1442V12.2042L21.0794 10.1764H20.5782V7.06125L18.5346 5H13.6405L11.5972 7.06125V10.1764H11.096L9.03115 12.2042V13.4118H7.41283L4.64511 10.6201L3.73797 11.5351L6.88176 14.7059H9.03115V17.2941H6.41736L3.4053 16.2817L3 17.5096L6.20946 18.5882H9.03113V21.1764H6.88174L3.73794 24.3472L4.64509 25.2622L7.4128 22.4705H9.0727L11.84 27H20.335L23.1026 22.4705H24.5871L27.3548 25.2622L28.262 24.3472L25.1182 21.1764H23.1442ZM12.8803 7.59734L14.1721 6.29428H18.0037L19.2953 7.59734V10.1766H12.8802L12.8803 7.59734ZM10.3143 22.0358V12.7503L11.6173 11.4708H15.4463V25.7062H12.5569L10.3143 22.0358ZM19.6187 25.706H16.7293V11.4705H20.5583L21.8613 12.7501V22.0356L19.6187 25.706Z",
    fill: "#327372"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFumigation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fumigation.0c3fe9ab.svg";
export { ForwardRef as ReactComponent };